import React from 'react';

export const EllipseIcon: React.FC = () => (
  <svg
    width='225'
    height='388'
    viewBox='0 0 225 388'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <foreignObject x='-50' y='-50' width='488' height='488'>
      <div
        style={{
          backdropFilter: 'blur(25px)',
          clipPath: 'url(#bgblur_0_42_5205_clip_path)',
          height: '100%',
          width: '100%',
        }}
      ></div>
    </foreignObject>
    <circle cx='194' cy='194' r='194' fill='url(#paint0_linear_42_5205)' fillOpacity='0.8' />
    <defs>
      <clipPath id='bgblur_0_42_5205_clip_path' transform='translate(50 50)'>
        <circle cx='194' cy='194' r='194' />
      </clipPath>
      <linearGradient
        id='paint0_linear_42_5205'
        x1='72.75'
        y1='388'
        x2='201.132'
        y2='37.8015'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D5DBEC' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
    </defs>
  </svg>
);

export const InfoCircleIcon: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0003 8.95829C10.3455 8.95829 10.6253 9.23812 10.6253 9.58329V13.75C10.6253 14.0951 10.3455 14.375 10.0003 14.375C9.65515 14.375 9.37533 14.0951 9.37533 13.75V9.58329C9.37533 9.23812 9.65515 8.95829 10.0003 8.95829Z'
      fill='#0055FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4268 5.78447C10.6833 6.01539 10.7041 6.41057 10.4732 6.66714L10.4649 6.6764C10.234 6.93296 9.83879 6.95376 9.58222 6.72285C9.32565 6.49194 9.30486 6.09676 9.53577 5.84019L9.5441 5.83093C9.77501 5.57436 10.1702 5.55356 10.4268 5.78447Z'
      fill='#0055FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0003 2.29163C5.74313 2.29163 2.29199 5.74276 2.29199 9.99996C2.29199 14.2572 5.74313 17.7083 10.0003 17.7083C14.2575 17.7083 17.7087 14.2572 17.7087 9.99996C17.7087 5.74276 14.2575 2.29163 10.0003 2.29163ZM1.04199 9.99996C1.04199 5.05241 5.05277 1.04163 10.0003 1.04163C14.9479 1.04163 18.9587 5.05241 18.9587 9.99996C18.9587 14.9475 14.9479 18.9583 10.0003 18.9583C5.05277 18.9583 1.04199 14.9475 1.04199 9.99996Z'
      fill='#0055FF'
    />
  </svg>
);

